import { Modal, useModals } from 'almanac-ui/Modal'
import { useCallback, useEffect } from 'react'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './IntegrationSuccessModal.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { getPlatformDisplayName } from 'utils/platformDisplayNames'
import { AutopilotInfo } from './AutopilotInfo'
import { SettingScreen } from 'components/Settings/types'
import { RoundedPlatformIcon } from 'components/RoundedPlatformIcon/RoundedPlatformIcon'
import { Heading } from 'blaze-ui/Heading/Heading'

interface Props {
  integration: ExternalIntegration
  onClose: (options?: { openSettingScreen?: SettingScreen }) => void
}

export const IntegrationSuccessModal = ({ integration, onClose }: Props) => {
  const { closeModal } = useModals()
  const workspace = useCurrentWorkspace()
  const isAutopilot = workspace?.is_virtual_marketer
  const showModal = isAutopilot && workspace.is_virtual_marketer_onboarding_completed

  const integrationName = getPlatformDisplayName(integration.provider)

  const handleClose = useCallback(
    (options?: { openSettingScreen?: SettingScreen }) => {
      closeModal()
      onClose(options)
    },
    [closeModal, onClose],
  )

  // only show the modal if autopilot is enabled and onboarded
  useEffect(() => {
    if (!showModal) {
      onClose()
    }
  }, [showModal, onClose])

  return (
    <Modal.Root
      size="sm"
      blaze
      onPressOutside={() => {}}
      onClose={handleClose}
      aria-label={`${integrationName} Account Connected Successfully`}
    >
      <Modal.Header title={`${integrationName} account connected!`} />
      <Modal.Content>
        <div className={Styles.content}>
          <div className={Styles.titleSection}>
            <div className={Styles.iconContainer}>
              <RoundedPlatformIcon platform={integration.provider} size={24} />
            </div>
            <Heading level={2}>Your {integrationName} content will start autoposting</Heading>
          </div>
          <AutopilotInfo integration={integration} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" onPress={() => handleClose()}>
            Confirm
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
